// config
import axios, { setAuthorization, handleResp } from "../config/axios";
// reducers
import { setAuthAccount } from '../redux/reducers/auth';
import { setProfile } from '../redux/reducers/profile';
// import lib
import { decodeJWT } from '../lib/auth';

export const login = async (data, dispatch) => {
    try {
        let respData = await axios({
            'url': `/adminapi/login`,
            'method': 'post',
            data
        });

        if (respData?.data?.tfaStatus === true) {
            return respData?.data
        };

        const { status, decoded } = decodeJWT(respData.data.token);
        if (!status) return { status, message: 'jwt decode error' };
        setAuthorization(respData.data.token)
        setAuthAccount(dispatch, decoded)
        getProfile(dispatch)
        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const getDashboard = async () => {
    try {
        let respData = await axios({
            'url': `/adminapi/dashboard`,
            'method': 'get'
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const addSubAdmin = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/sub-admin`,
            'method': 'post',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const editSubAdmin = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/sub-admin`,
            'method': 'put',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const getSubAdmin = async (params) => {
    try {
        let respData = await axios({
            'url': `/adminapi/sub-admin`,
            'method': 'get',
            params
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const getProfile = async (dispatch) => {
    try {
        let respData = await axios({
            'url': `/adminapi/get-profile`,
            'method': 'get'
        });

        setProfile(dispatch, respData?.data?.result)
        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const updateProfile = async (data, dispatch) => {
    try {
        let respData = await axios({
            'url': `/adminapi/update-profile`,
            'method': 'post',
            data
        });
        getProfile(dispatch)
        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const generate2fa = async (dispatch) => {
    try {
        let respData = await axios({
            'url': `/adminapi/generate-2fa`,
            'method': 'get'
        });

        setProfile(dispatch, { google2Fa: respData?.data?.result })
        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const verify2fa = async (data, dispatch) => {
    try {
        let respData = await axios({
            'url': `/adminapi/verify-tfa`,
            'method': 'post',
            data
        });

        getProfile(dispatch)
        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const addAuthor = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/author`,
            'method': 'post',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const editAuthor = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/author`,
            'method': 'put',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const getAuthorList = async (params) => {
    try {
        let respData = await axios({
            'url': `/adminapi/author`,
            'method': 'get',
            params
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const getAuthorAll = async (params) => {
    try {
        let respData = await axios({
            'url': `/adminapi/author-all`,
            'method': 'get',
            params
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const getContactList = async (params) => {
    try {
        let respData = await axios({
            'url': `/adminapi/contact`,
            'method': 'get',
            params
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const createBlog = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/blog`,
            'method': 'post',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const editBlog = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/blog`,
            'method': 'put',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const getBlog = async (params) => {
    try {
        let respData = await axios({
            'url': `/adminapi/blog`,
            'method': 'get',
            params
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const blogSeoEdit = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/seo-blog-edit`,
            'method': 'post',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const getBlogSeo = async (blogId) => {
    try {
        let respData = await axios({
            'url': `/adminapi/seo-blog/${blogId}`,
            'method': 'get'
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const updateBlogStatus = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/blog`,
            'method': 'patch',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const updateIsMain = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/blog/is-main`,
            'method': 'post',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const deleteBlog = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/blog`,
            'method': 'delete',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const getFaq = async (params) => {
    try {
        let respData = await axios({
            'url': `/adminapi/faq`,
            'method': 'get',
            params
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}


export const createFaq = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/faq`,
            'method': 'post',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const editFaq = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/faq`,
            'method': 'put',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const updateFaqStatus = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/faq`,
            'method': 'patch',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const deleteFaq = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/faq`,
            'method': 'delete',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}


export const createWork = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/work`,
            'method': 'post',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const editWork = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/work`,
            'method': 'put',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const getWork = async (params) => {
    try {
        let respData = await axios({
            'url': `/adminapi/work`,
            'method': 'get',
            params
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const updateWorkStatus = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/work`,
            'method': 'patch',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const deleteWork = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/work`,
            'method': 'delete',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const workSeoEdit = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/seo-work-edit`,
            'method': 'post',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const getWorkSeo = async (blogId) => {
    try {
        let respData = await axios({
            'url': `/adminapi/seo-work/${blogId}`,
            'method': 'get'
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const createTestimonial = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/testimonial`,
            'method': 'post',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const editTestimonial = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/testimonial`,
            'method': 'put',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const getTestimonial = async (params) => {
    try {
        let respData = await axios({
            'url': `/adminapi/testimonial`,
            'method': 'get',
            params
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const updateTestimonialStatus = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/testimonial`,
            'method': 'patch',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const deleteTestimonial = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/testimonial`,
            'method': 'delete',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

/* BLOG FAQ */
export const getBlogFaq = async (params) => {
    try {
        let respData = await axios({
            'url': `/adminapi/blog-faq`,
            'method': 'get',
            params
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}


export const createBlogFaq = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/blog-faq`,
            'method': 'post',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const editBlogFaq = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/blog-faq`,
            'method': 'put',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const updateBlogFaqStatus = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/blog-faq`,
            'method': 'patch',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}

export const deleteBlogFaq = async (data) => {
    try {
        let respData = await axios({
            'url': `/adminapi/blog-faq`,
            'method': 'delete',
            data
        });

        return handleResp(respData)
    } catch (err) {
        return handleResp(err.response)
    }
}